export default "__VITE_ASSET__BNSs2w_e__"